/* eslint-disable */
import Vue from 'vue'
import VueRouter from 'vue-router'
import apiSessionService from '@/services/http/session/ApiSessionService'
import store from '@/store/index'
import HttpError from '@/objects/Exceptions/HttpError'
import { EVENTS, EventBus } from '@/services/events/EventBus'
let appInitialzed = false

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'auth.login',
    component: () => import(/* webpackChunkName: "settings" */ '../views/request-login/RequestLogin.vue'),
  },
  {
    path: '/auth/check-mail',
    name: 'auth.token-sent',
    component: () => import(/* webpackChunkName: "settings" */ '../views/request-login/RequestSuccess.vue'),
  },
  {
    path: '/auth/welcome',
    name: 'auth.welcome',
    redirect: to => {
      if(to.query && to.query.email) {
        store.commit('userprofile/SET_EMAIL', to.query.email)
      } else {
        console.warn('No email set in url')
      }

      return '/auth/check-mail'
    }
  },
  {
    path: '/',
    name: 'home',
    redirect: '/home'
  },
  {
    path: '/index.html',
    redirect: '/home'
  },
  {
    path: '/onboarding',
    name: 'onboarding',
    component: () => import(/* webpackChunkName: "home" */ '../views/onboarding/Onboarding.vue'),
    beforeEnter: (to, from, next) => isAuthenticatedGuard(to, from, next)
  },

  {
    path: '/pre-check-in',
    redirect: '/home'
    /*
      We do not use the pre-checkin anymore. This is done via MEWS
     */
    // name: 'pre-checkin',
    // component: () => import(/* webpackChunkName: "settings" */ '../views/pre-check-in/PreCheckIn'),
    // beforeEnter: (to, from, next) => isAuthenticatedGuard(to, from, next)
  },
  // {
  //   path: '/settings',
  //   name: 'Settings',
  //   component: () => import(/* webpackChunkName: "settings" */ '../views/settings/Settings.vue'),
  //   beforeEnter: (to, from, next) => isOnboardedGuard(to, from, next)
  // },
  {
    path: '/settings/booking-history',
    name: 'bookingHistory',
    component: () => import(/* webpackChunkName: "settings" */ '../sections/settings/BookingHistory.vue'),
    beforeEnter: (to, from, next) => isAuthenticatedGuard(to, from, next)
  },
  {
    path: '/settings/booking-history/:bookingId',
    name: 'bookingHistory.detail',
    component: () => import(/* webpackChunkName: "settings" */ '../sections/settings/Booking.vue'),
    beforeEnter: (to, from, next) => isAuthenticatedGuard(to, from, next)
  },
  {
    path: '/settings/my-account',
    name: 'My Account',
    component: () => import(/* webpackChunkName: "settings" */ '../sections/settings/MyAccount.vue'),
    beforeEnter: (to, from, next) => isAuthenticatedGuard(to, from, next)
  },
  {
    path: '/settings/invite-friend',
    name: 'settings.invitefriend',
    component: () => import(/* webpackChunkName: "settings" */ '../sections/settings/InviteFriend.vue'),
    beforeEnter: (to, from, next) => isAuthenticatedGuard(to, from, next)
  },
  // {
  //   path: '/no-cms-setup/section-news',
  //   name: 'news',
  //   component: () => import(/* webpackChunkName: "home" */ '../views/news/News.vue'),
  //   beforeEnter: (to, from, next) => isCheckInGuard(to, from, next)
  // },
  // {
  //   path: '/no-cms-setup/section-news/:article',
  //   name: 'article',
  //   component: () => import(/* webpackChunkName: "home" */ '../views/content/Content.vue'),
  //   beforeEnter: (to, from, next) => isAuthenticatedGuard(to, from, next)
  // },
  // {
  //   path: '/no-cms-setup/about',
  //   name: 'about',
  //   component: () => import(/* webpackChunkName: "home" */ '../views/content/Content.vue'),
  //   beforeEnter: (to, from, next) => isAuthenticatedGuard(to, from, next)
  // },
  // {
  //   path: '/no-cms-setup/extra-services',
  //   name: 'extra-services',
  //   component: () => import(/* webpackChunkName: "home" */ '../views/content/Content.vue'),
  //   beforeEnter: (to, from, next) => isAuthenticatedGuard(to, from, next)
  // },
  // {
  //   path: '/no-cms-setup/more-information',
  //   name: 'more-information',
  //   component: () => import(/* webpackChunkName: "home" */ '../views/content/Content.vue'),
  //   beforeEnter: (to, from, next) => isAuthenticatedGuard(to, from, next)
  // },
  // {
  //   path: '/upsell-products',
  //   name: 'UpsellProducts',
  //   component: () => import(/* webpackChunkName: "services" */ '../views/upsell-product/UpsellProducts.vue'),
  //   beforeEnter: (to, from, next) => isAuthenticatedGuard(to, from, next)
  // },
  {
    path: '/upsell-products/:serviceId/:id',
    name: 'UpsellProduct',
    component: () => import(/* webpackChunkName: "services" */ '../views/upsell-product/UpsellProduct.vue'),
    beforeEnter: (to, from, next) => isAuthenticatedGuard(to, from, next)
  },
  // {
  //   path: '/no-cms-setup/debug/notifications',
  //   name: 'Notifications',
  //   component: () => import(/* webpackChunkName: "settings" */ '../views/debug/Notifications.vue'),
  //   beforeEnter: (to, from, next) => isAuthenticatedGuard(to, from, next)
  // },
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "settings" */ '../views/not-found/NotFound.vue'),
  },
  {
    path: '/:collection/:slug?',
    name: 'View',
    component: () => import(/* webpackChunkName: "settings" */ '../views/view/View.vue'),
    beforeEnter: (to, from, next) => isAuthenticatedGuard(to, from, next)
  },
  {
    path: '/:catchAll(.*)', redirect:'404'
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



EventBus.$on(EVENTS.UnauthenticatedRequest, () => {
  console.log('Handle unauth request')
  store.commit('userprofile/RESET_PROFILE')
  router.push({name: 'auth.login'})
})



const removeSplashscreen = () => {
  setTimeout(() => {
    const preLoader = document.querySelector('.temp-preloader')
    if (!preLoader) return
    preLoader.classList.add('hide')
    preLoader.addEventListener('transitionend', () => {
      preLoader.remove()
    })
  }, 500)
}



const isAuthenticatedGuard = async (to, from, next) => {
  const auth = await isAuthenticated(to, from, next)
  if (auth) {
    next()
  }
}

/*
Depricated. We don't do the onboarding in the App anymore
 */
const isOnboardedGuard = async (to, from, next) => {
  await isAuthenticated(to, from, next)
  const boarded = await isOnboarded(to, from, next)
  if (boarded) {
    next()
  }
}

// TODO: Add guard for pre-checkin
// const isPreCheckedInGuard = async (to, from, next) => {
//   await isAuthenticated(to, from, next)
//   const boarded = await isOnboarded(to, from, next)
//   if (boarded) {
//     next()
//   }
// }

const isAuthenticated = async (to, from, next) => {
  if (store.state.userprofile.authenticated === undefined ) {
    const profile = await initialAuthCheck()
  }

  if (store.state.userprofile.authenticated === false) {
    return next({name: 'auth.login'})
  }

  removeSplashscreen()
  return true
}

/*
Depricated. We don't do onboarding anymore
 */
const isOnboarded = async (to, from, next) => {
  if (!store.state.userprofile.profile.onboarded_at) {
    return next({name: 'onboarding'})
  }

  return true
}

const initialAuthCheck = async () => {
  await apiSessionService.setCookie()
  const profile = await store.dispatch('userprofile/fetchProfile')
  return profile
}






export default router
apiSessionService.setCookie()
